import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionSkill,
  CvSectionSkillResponse,
  UpdateCvSectionSkillRequest,
} from '@/../gen';

export const namespace = 'cvSectionSkillEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_Skill');
export const SetCvSectionSkill = actionCreator<CvSectionSkillResponse>(
  'SET_CV_SECTION_Skill'
);
export const UpdateCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
  body: UpdateCvSectionSkillRequest;
}>('UPDATE_CV_SECTION_Skill');
export const DeleteCvSectionSkill = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_Skill');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionSkill: CvSectionSkill;
}

const initialState = (): State => {
  return { cvSectionSkill: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionSkill, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkill(data.data));
    }),
    action(UpdateCvSectionSkill, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionSkill(data.data));
    }),
    action(DeleteCvSectionSkill, async function(context, action) {
      await this.proffApi.deleteCvSectionSkill(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionSkill(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionSkill, (state, action) => {
      state.cvSectionSkill = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionSkill: state => state.cvSectionSkill,
  },
};
